"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroy = exports.reauthenticate = exports.logout = exports.init = void 0;
var auth_cage_1 = require("@shortlyster/auth-cage");
var config = {};
var jwtFn = function (callback) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenUrl, token, userToken, storage, persistedData, auth, user, err_1, headers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tokenUrl = config.tokenUrl, token = config.token;
                if (!tokenUrl)
                    return [2 /*return*/];
                userToken = token;
                if (!!userToken) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                storage = new auth_cage_1.default(tokenUrl.replace('/zendesk', '')).storage;
                return [4 /*yield*/, storage.getItem('persist:shortlyster')];
            case 2:
                persistedData = _a.sent();
                auth = JSON.parse(persistedData).auth;
                user = JSON.parse(auth);
                userToken = user.token;
                return [3 /*break*/, 4];
            case 3:
                err_1 = _a.sent();
                return [3 /*break*/, 4];
            case 4:
                headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Bearer " + userToken });
                fetch(tokenUrl, { method: 'POST', headers: headers })
                    .then(function (response) { return response.json(); })
                    .then(function (_a) {
                    var token = _a.token;
                    return callback(token);
                });
                return [2 /*return*/];
        }
    });
}); };
var injectScript = function () {
    var key = config.key;
    if (!key)
        return;
    // inject zendesk widget script
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', 'ze-snippet');
    script.setAttribute('async', 'true');
    script.setAttribute('src', "https://static.zdassets.com/ekr/snippet.js?key=" + key);
    document.body.appendChild(script);
};
var init = function (key, settings, tokenUrl, token) {
    if (settings === void 0) { settings = {}; }
    config.key = key;
    config.tokenUrl = tokenUrl;
    config.token = token;
    window.zESettings = settings;
    // inject settings for JWT resolution
    if (tokenUrl) {
        if (!(settings === null || settings === void 0 ? void 0 : settings.webWidget)) {
            window.zESettings = { webWidget: { authenticate: { jwtFn: jwtFn } } };
        }
        else {
            window.zESettings.webWidget.authenticate = { jwtFn: jwtFn };
        }
    }
    window.addEventListener('load', injectScript);
};
exports.init = init;
var logout = function () {
    // Hide the widget while logging out so that it resets
    window.zE('webWidget', 'close');
    window.zE('webWidget', 'logout');
};
exports.logout = logout;
var reauthenticate = function () {
    window.zE('webWidget', 'helpCenter:reauthenticate');
};
exports.reauthenticate = reauthenticate;
var destroy = function () {
    // Remove the zendesk script from the page
    var zeScriptNode = document.getElementById('ze-snippet');
    zeScriptNode.parentElement.removeChild(zeScriptNode);
};
exports.destroy = destroy;
